import React, { Component } from "react";
import { Button, Form, Icon, Message, Divider } from "semantic-ui-react";
import Flatpickr from "react-flatpickr";
import request from "../../../utils/request";
import moment from "moment";

const dateTimePicker = {
  enableTime: true,
  dateFormat: "Y-m-d H:i"
};

class SecondaryPrizeDraw extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawId: "",
      event: props.event,
      eventOptions: [],
      isLoading: false,
      isMounted: false,
      priceOptions: [],
      prices: [],
      prizes: [],
      xhrMessage: "",
      xhrStatus: false,
      drawDate: "",
      end: "",
      eventId: props.eventId,
      eventIds: [],
      notes: "",
      prize: "",
      prizeCount: 1,
      start: "",
      disableSave: false,
      minutesOffset: 0,
      timeRangeStart: "",
      timeRangeEnd: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleResponse = this.handleResponse.bind(this);
  }
  componentDidMount = () => {
    this.setState({ isMounted: true });
  };
  componentDidUpdate = prevProps => {
    if (this.props.eventId !== prevProps.eventId) {
      this.setState({ event: this.props.event });
    }
  };
  handleChange = (e, { name, value }) => {
    if (name === "prizeCount") {
      if (isNaN(value) || value === "") {
        value = "";
      } else {
        value = Math.max(1, parseInt(value));
      }
    }
    this.setState({ [name]: value })
  };
  handleReset = () => {
    this.setState({
      drawDate: "",
      drawId: "",
      end: "",
      eventIds: [],
      notes: "",
      prices: [],
      prize: "",
      prizeCount: 1,
      start: "",
      disableSave: false,
      minutesOffset: 0,
      timeRangeStart: "",
      timeRangeEnd: ""
    });
  };
  handleSubmit = e => {
    this.setState({ isLoading: true });
    let payload = {
      drawDate: this.state.drawDate,
      drawId: this.state.drawId,
      end: this.state.timeRangeEnd,
      eventId: this.state.eventId,
      eventIds: this.state.event ? [this.state.eventId] : this.state.eventIds,
      notes: "",
      pricepoint: this.state.prices,
      prize: this.state.prize,
      prizeCount: this.state.prizeCount,
      start: this.state.timeRangeStart
    };
    request.post(this, "api:/event/" + this.state.eventId + "/secondary-draw", payload, this.handleResponse);
  };
  handleResponse = resp => {
    this.setState({
      isLoading: false,
      xhrStatus: resp.status,
      xhrMessage: resp.message
    });
    this.handleReset();
  };
  render() {
    const {
      xhrStatus,
      xhrMessage,
      isLoading,
      prices,
      priceOptions,
      eventOptions,
      eventIds,
      minutesOffset
    } = this.state;
    return (
      <Form
        id="secondaryPrize"
        loading={isLoading}
        success={xhrStatus === "success"}
        error={xhrStatus === "error"}
        warning={+minutesOffset > 0}
      >
        <h3>Add Secondary Prize</h3>
        <Divider></Divider>
        <Message success content={xhrMessage} />
        <Message error content={xhrMessage} />
        <Message warning content="Scheduled draw time must end with a 0 or 5" />
        <Form.Group>
          {typeof eventId !== "undefined" && (
            <Form.Select
              name="eventIds[]"
              fluid
              label="Event(s)"
              placeholder="Event(s)"
              multiple
              search
              options={eventOptions}
              value={eventIds}
              onChange={this.handleChange}
              width={16}
            />
          )}
          <Form.Input
            name="prizeCount"
            fluid
            label="Quantity"
            placeholder="Quantity"
            value={this.state.prizeCount}
            onChange={this.handleChange}
            width={3}
            required
          />
          <Form.Input
            type="text"
            name="prize"
            fluid
            label="Prize"
            placeholder="Prize"
            value={this.state.prize}
            onChange={this.handleChange}
            width={14}
            required
          />
        </Form.Group>
        <Form.Field>
          <label>Automatically draw prize on:</label>
          <Flatpickr
            name="drawDate"
            value={this.state.drawDate || ""}
            placeholder="Draw Date"
            options={dateTimePicker}
            onValueUpdate={(_, str, b) => {
              // how many minutes to add to round to nearest 0/5
              let offset = moment(str).format("mm");
              offset = (offset%5 != 0) ? 5 - offset%5 : 0;
              this.setState({
                drawDate: moment(str).add(offset, 'minutes').format("YYYY-MM-DD hh:mm"),
                minutesOffset: offset
              });
            }}
            onOpen={() => {
              this.setState({ disableSave: true });
            }}
            onClose={() => {
              this.setState({ disableSave: false });
            }}
          />
        </Form.Field>
        <h4>Draw Criteria:</h4>
        <Form.Group widths={2}>
          <Form.Field>
            <label>Start:</label>
            <Flatpickr
              name="timeRangeStart"
              value={this.state.timeRangeStart || ""}
              placeholder="Start"
              options={dateTimePicker}
              onChange={(_, str, b) =>
                this.handleChange(b.element, {
                  name: "timeRangeStart",
                  value: str
                })
              }
            />
          </Form.Field>
          <Form.Field>
            <label>End:</label>
            <Flatpickr
              name="timeRangeEnd"
              value={this.state.timeRangeEnd || ""}
              placeholder="End"
              options={dateTimePicker}
              onChange={(_, str, b) =>
                this.handleChange(b.element, {
                  name: "timeRangeEnd",
                  value: str
                })
              }
            />
          </Form.Field>
        </Form.Group>
        {false && <Form.Select
          name="prices"
          fluid
          label="Limit to Price Point(s)"
          placeholder="Price Point(s)"
          multiple
          search
          options={priceOptions}
          value={prices}
          onChange={this.handleChange}
          width={16}
        />}
        <Button type="button" primary loading={isLoading} fluid onClick={this.handleSubmit} disabled={this.state.prize==="" || this.state.prizeCount==="" || this.state.disableSave || +minutesOffset > 0}>
          <Icon name="save" /> Save
        </Button>
      </Form>
    );
  }
}

export default SecondaryPrizeDraw;
